import { ProductDoc, ProductInventoryDoc, ProductSupplierDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { observeProductSupplier, observeProducts } from 'src/utils/firebase/firebase-short-cut';

interface UseProductsProps {
  mergeSupplier?: boolean;
}

export type ProductDetailRow = ProductDoc & {
  inventory: ProductInventoryDoc | undefined;
  supplier: ProductSupplierDoc | undefined;
};

type ProductResult<T extends UseProductsProps | undefined> = T extends { mergeSupplier: true }
  ? ProductDetailRow[]
  : ProductDoc[];

const useProductsWithOptions = <T extends UseProductsProps | undefined>(props?: T): ProductResult<T> => {
  const { mergeSupplier } = props || {};
  const [products, setProducts] = useState<ProductResult<T>>([]);

  useEffect(() => {
    const product$ = observeProducts();
    const productSupplier$ = observeProductSupplier();

    const subscription = (
      mergeSupplier
        ? combineLatest([product$, productSupplier$]).pipe(
            map(([products, suppliers]) =>
              products.map((product) => {
                const supplier = suppliers.find((sup) => sup._id === product.supplierId);
                return {
                  ...product,
                  supplier,
                };
              })
            )
          )
        : product$
    ).subscribe((products) => setProducts(products as ProductResult<T>));

    return () => subscription.unsubscribe();
  }, [mergeSupplier]);

  return products;
};

export default useProductsWithOptions;
